
export class UpdateSettingsDataRequest {
    setting: string = '';
    value: string = '';
}